//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.UserDefinedColorScaleData.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"ColorScaleOption",1,0],[0,"IsFixed",1,0],[0,"Max",1,0],[0,"Middle",1,0],[0,"MiddleScale",1,0],[0,"Min",1,0],[0,"NumberOfColors",1,0],[1,"UserDefinedColorScale",0,"GeometricUtilities.UserDefinedColorScaleData",0],[0,"ZoomScale",1,0]],[[[],"ResetData",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricAnalysis.FaceAnalysisDataRangeBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.FaceAnalysisDataRangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.FaceAnalysisDataRangeBuilder.ColorScaleOptions = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

SPLM.GeometricAnalysis.FaceAnalysisDataRangeBuilder.NumberOfColorsOptions = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven", "Twelve" : "Twelve"});

export default SPLM;